import { ServiceCode, ServiceOrganizationRole } from '@common/enums';
import { getServiceOrganizationRoles } from '../../utils/serviceOrganizationRolesUtils';

export function getServiceOrganizationRolesSelectableForDistributions(
    serviceCode: ServiceCode
): ServiceOrganizationRole[] {
    const rolesForService = getServiceOrganizationRoles(serviceCode);
    let rolesSelectableForDistributions: ServiceOrganizationRole[] = [];

    if (serviceCode === ServiceCode.BariPre) {
        rolesSelectableForDistributions = [ServiceOrganizationRole.psychology, ServiceOrganizationRole.dietetics];
    }

    if (serviceCode === ServiceCode.BariPost) {
        rolesSelectableForDistributions = [
            ServiceOrganizationRole.psychology,
            ServiceOrganizationRole.dietetics,
            ServiceOrganizationRole.lifestyleCoaching,
        ];
    }

    return rolesForService.filter((role) => rolesSelectableForDistributions.includes(role));
}
